import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../data/mockData';

const Testimonials = () => {
  return (
    <section className="section-padding bg-card relative z-10">
      <div className="container mx-auto px-5 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-16 scroll-reveal">
          <h2 className="heading-2 mb-6">מה אומרים עלינו</h2>
          <p className="body-medium text-secondary max-w-2xl mx-auto">
            חוות דעת אמיתיות ממתאמנים שלנו
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id}
              className="testimonial-card scroll-reveal-scale"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-6 relative z-10">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star 
                    key={i}
                    size={20}
                    className="fill-wood-lighter text-wood-lighter"
                  />
                ))}
              </div>

              {/* Text */}
              <p className="body-medium text-primary mb-6 relative z-10">
                "{testimonial.text}"
              </p>

              {/* Name */}
              <p className="caption text-wood-light relative z-10">
                {testimonial.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
